import { Component, DoCheck, Input, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgComponentOutlet } from '@angular/common';
import { ThomasConversationService, ThomasMessage, ThomasReply } from './thomas-conversation.service';
import { thomasMarkdown } from './thomas-markdown';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- shared Thomas markup uses the js- prefix in every app
  selector: 'js-thomas-reply',
  templateUrl: './thomas-reply.component.html',
  imports: [FormsModule, NgComponentOutlet]
})
export class ThomasReplyComponent implements DoCheck {

  @Input({ required: true }) message!: ThomasMessage;

  html = '';
  private renderedText: string | null = null;
  private renderedPhase: string | null = null;

  thomas = inject(ThomasConversationService);

  get reply(): ThomasReply {
    return this.message.reply!;
  }

  get showFeedbackForm(): boolean {
    const feedback = this.reply.feedback;
    return feedback.selection !== null && (!feedback.submitted || feedback.editing);
  }

  // A terminal event can change phase/cards without changing text. dxChat then
  // retains the template and its shared reply state, so OnChanges alone misses it.
  ngDoCheck() {
    const phase = this.reply.phase;
    if (this.renderedText === this.message.text && this.renderedPhase === phase) {
      return;
    }
    this.renderedText = this.message.text;
    this.renderedPhase = phase;
    if (phase === 'thinking' || phase === 'error') {
      this.html = '';
      return;
    }
    this.html = thomasMarkdown(this.message.text);
  }
}
